import { j as o } from "../../../jsx-runtime-B6kdoens.js";
import { a as s } from "../../../index-CROKJrb5.js";
import { c as n, f as p } from "../../../create-component-CBAeEoQ6.js";
const x = n(
  "NavigationBar",
  p(
    ({ as: r, children: c, className: t, ...u }, a) => {
      const e = r || "div";
      return /* @__PURE__ */ o.jsx(
        e,
        {
          className: s(
            "cur-z-20 cur-flex cur-h-full cur-w-full cur-flex-nowrap cur-items-stretch cur-justify-between cur-gap-2 cur-bg-surface-neutral cur-px-2 cur-py-2 md:cur-px-4 xl:cur-px-10",
            t
          ),
          ref: a,
          ...u,
          children: c
        }
      );
    }
  )
);
export {
  x as NavigationBar
};
//# sourceMappingURL=index.js.map
